/*
Copyright(c) 2024 Venditio
*/

import { ObjectId } from "../utils";
import { TrainingAction, TrainingActionTypes } from "./training.actions";
import { TrainingState, initialTrainingState } from "./training.model";
/**************************************************************************
Users
  roll can be care taker or parent
  parents can edit the training, care takers can view the training
  SetUser and SetPlay update the user roll

Bootstrap
  When a patient is selected SetPlay
    task_index is set to zero to select the first task
    setTaskIndex will select the first scene of the task

Navigation
   To Navigate the user can select a different task SetTaskIndex
   a different scene SetTaskIndex
   PlayScene can set the act and scene index called by the bar
      under the desktop video, by overview or by the other participant in the call
Modifications
    AddTask creates a new task with a single scene
    DelTask set del_movies to tell the service to remove them from S3
    SetScene calls setScene to modify the scene name, start or end
      setScene creates a new scene if there is free space after the new scene
Zoom and Pan
    SetZoom
    SetPan
    DelStep removes the step
    AddStep //Not implemented, steps are added automatically at the end

Recording
  SetMIME is use to set the mime type and extension for the device
  DoneRecording called after the recording is uploaded to S3 to modify the model
  DelTeacherVideo deletes the teaching video task
**************************************************************************/



export function trainingReducer(state = initialTrainingState,
  action: TrainingAction): TrainingState {
  switch (action.type) {

    case TrainingActionTypes.AddPatient: {
      const trainingState: TrainingState = Object.assign({}, state);

      trainingState.play = {
        _id: action.patient_id,
        patient_id: action.patient_id,
        first_name: action.first_name,
        last_name: action.last_name,
        new: true
      }
      trainingState.save_play = trainingState.play //save IT
      let patients = Object.assign({}, trainingState.patients)
      patients[action.patient_id] = trainingState.play
      trainingState.patients = patients
      /*
      The new patient is created by the server and it is added to the db
      */

      return trainingState;

    }
    case TrainingActionTypes.SaveScene: {
      const trainingState: TrainingState = Object.assign({}, state);
      let str1 = JSON.stringify(trainingState.save_play)
      let str2 = JSON.stringify(trainingState.play)
      if (str1 != str2) {
        trainingState.save_play = trainingState.play
      }
      return trainingState;
    }
    //Users
    case TrainingActionTypes.SetUser: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.user = action.user
      trainingState.progress = action.user.progress
      trainingState.roll = action.user.roll
      if (trainingState.play && trainingState.play.users && trainingState.user) {
        trainingState.roll = trainingState.play.users[trainingState.user._id].roll
      }
      return trainingState;
    }
    case TrainingActionTypes.AddUser: {
      const trainingState: TrainingState = Object.assign({}, state);
      if (trainingState.play) {
        let play = Object.assign({}, trainingState.play)
        let users = Object.assign({}, play.users)
        users[action.user._id] = action.user
        play.users = users
        trainingState.play = play
        //Make sure the new user has the current patient
        let patient_id = play._id
        let user = Object.assign({}, trainingState.user)
        if (user.email) {
          if (!user.patients) {
            user.patients = {}
          }
          if (!user.patients[patient_id]) {
            let user_patients = Object.assign({}, user.patients)
            user_patients[patient_id] = {
              first_name: play.first_name,
              last_name: play.last_name,
              roll: "parent"
            }
            user.patients = user_patients
            trainingState.user = user
          }
        }

        // trainingState.save_play = play the db is allready updated
      }

      return trainingState;
    }
    case TrainingActionTypes.DeleteUser: {
      const trainingState: TrainingState = Object.assign({}, state);
      if (trainingState.play) {
        let play = Object.assign({}, trainingState.play)
        let users = Object.assign({}, play.users)
        delete users[action.user_id]
        play.users = users
        trainingState.play = play
        // trainingState.save_play = play, the db is allready updated
      }

      return trainingState;
    }

    case TrainingActionTypes.SetPatientName: {
      const trainingState: TrainingState = Object.assign({}, state);
      let play = Object.assign({}, trainingState.play)
      if (play.first_name != action.first_name || play.last_name != action.last_name) {
        play.first_name = action.first_name
        play.last_name = action.last_name
        trainingState.play = play
      }
      return trainingState;
    }
    //Bootstrap
    case TrainingActionTypes.SetPlay: {
      console.log("training SetPlay")
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.play = action.play
      if (trainingState.play._id) {
        if (trainingState.user && trainingState.user._id && trainingState.play.users && trainingState.play) {
          trainingState.roll = trainingState.play.users[trainingState.user._id].roll
        }
        if (trainingState.play.tasks && trainingState.play.tasks.length == 1 && trainingState.task_index < 0) {
          setTaskIndex(trainingState, 0)
        }
      } else {
        trainingState.task_index = -1
        trainingState.scene_index = -1
        trainingState.zoom = 1
        trainingState.remote_zoom_pan = undefined
      }
      return trainingState;
    }
    //Navigation
    case TrainingActionTypes.SetTaksIndex: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.task_index = action.index
      if (trainingState.task_index >= 0) { //Don't reset it when the user is going back
        setTaskIndex(trainingState, action.index)
      }
      return trainingState;
    }
    case TrainingActionTypes.SetSceneIndex: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.scene_index = action.index
      return trainingState;
    }

    case TrainingActionTypes.PlayScene: {
      console.log("PlayScene")
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.scene_index = action.index
      trainingState.act = action.act
      return trainingState;
    }

    //Modifications
    case TrainingActionTypes.AddTask: {
      const trainingState: TrainingState = Object.assign({}, state);

      let task = {
        "name": action.name,
        "task_key": new Date().getTime(),
        "task_index": 0,
        "scenes": [
          {
            "name": "Step 1",
            "start": 0,
            "index": 0
          }
        ]
      }
      let play = Object.assign({}, trainingState.play)
      let tasks = Object.assign([], play.tasks)
      trainingState.task_index = tasks.length
      trainingState.scene_index = 0
      tasks[trainingState.task_index] = task
      play.tasks = tasks;
      trainingState.play = play

      trainingState.save_play = play //AddTask
      return trainingState;
    }

    case TrainingActionTypes.DelTask: {
      const trainingState: TrainingState = Object.assign({}, state);
      if (trainingState.play && trainingState.play.tasks && trainingState.task_index < trainingState.play.tasks.length) {
        let play = Object.assign({}, trainingState.play)
        let tasks = Object.assign([], play.tasks)
        let task = Object.assign({}, tasks[trainingState.task_index])
        if (task) {
          trainingState.del_movies = {
            movies: task.play_movies,
            patient_id: play._id,
            task_key: task.task_key
          }
        }

        tasks.splice(trainingState.task_index, 1)
        play.tasks = tasks
        trainingState.task_index = -1
        trainingState.scene_index = -1

        trainingState.play = play
        trainingState.save_play = play //DelTask
      }
      return trainingState
    }

    case TrainingActionTypes.SetScene: {
      // console.log("training reducer SetSceneStart")
      const trainingState: TrainingState = Object.assign({}, state);
      setScene(trainingState, action.name, parseFloat(action.start.toFixed(3)), parseFloat(action.end.toFixed(3)))
      return trainingState;
    }
    case TrainingActionTypes.DelStep: {
      const trainingState: TrainingState = Object.assign({}, state);
      delStep(trainingState, action.index)
      return trainingState;
    }
    //Zoom Pan
    case TrainingActionTypes.ZoomIn: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.zoom += 0.25
      return trainingState;
    }

    case TrainingActionTypes.ZoomOut: {
      const trainingState: TrainingState = Object.assign({}, state);
      if (trainingState.zoom > 1) {
        trainingState.zoom -= 0.25
      }
      return trainingState;
    }
    case TrainingActionTypes.Zoom: {
      const trainingState: TrainingState = Object.assign({}, state);
      if (action.zoom >= 1) {
        trainingState.zoom = action.zoom
      }
      return trainingState;
    }
    case TrainingActionTypes.SetZoomOrPan: {
      const trainingState: TrainingState = Object.assign({}, state);
      setZoomAndPan(trainingState, action.msg)
      return trainingState;
    }
    case TrainingActionTypes.RemoteZoomOrPan: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.remote_zoom_pan = action.msg //This will trigrer the selector in care
      setZoomAndPan(trainingState, action.msg)
      return trainingState;
    }

    //Sketches
    case TrainingActionTypes.SetSketch: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.last_sketch = action.sketch
      return trainingState;
    }
    case TrainingActionTypes.SetSketchIndex: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.sketch_index = action.index
      return trainingState;
    }
    case TrainingActionTypes.DelSketch: {
      const trainingState: TrainingState = Object.assign({}, state);
      delSketchAt(trainingState, action.index)
      return trainingState;
    }
    case TrainingActionTypes.SetSketches: {
      const trainingState: TrainingState = Object.assign({}, state);
      setTaskSketcehs(trainingState, action.sketches, action.scene_index)
      return trainingState;
    }

    //Recording

    case TrainingActionTypes.StopRec: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.stop++
      return trainingState;
    }
    case TrainingActionTypes.Rec: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.rec_count++

      return trainingState;
    }
    case TrainingActionTypes.SetMIME: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.mime_ext = action.mime_ext
      trainingState.mime_type = action.mime_type
      return trainingState;
    }
    case TrainingActionTypes.DoneRecording: {
      const trainingState: TrainingState = Object.assign({}, state);
      doneRecording(trainingState, action.duration, action.bIsTask, action.data)
      trainingState.rec_count = 0
      return trainingState;
    }
    case TrainingActionTypes.DelTeacherVideo: {
      const trainingState: TrainingState = Object.assign({}, state);
      delTeacherVideo(trainingState, action.index, action.act)
      return trainingState;
    }

    //Playing
    case TrainingActionTypes.Play: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.play_it++;
      return trainingState;
    }
    case TrainingActionTypes.Pause: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.pause++;
      return trainingState;
    }
    case TrainingActionTypes.SetCurrTime: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.curr_time = action.curr_time;
      return trainingState;
    }

    case TrainingActionTypes.OtherRec: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.other_rec_count++
      return trainingState;
    }



    case TrainingActionTypes.UpdateProgress: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.progress = action.progress
      return trainingState;
    }
    //**************************************************************************
    // End MAY 2025
    //**************************************************************************

    /////



    //used when there is a new call
    case TrainingActionTypes.ClearTraining: { //Clears the state
      let patients = state.patients
      const trainingState: TrainingState = Object.assign({}, initialTrainingState);
      trainingState.patients = patients
      return trainingState;
    }
    case TrainingActionTypes.GotPatients: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.patients = action.patients
      return trainingState;
    }
    case TrainingActionTypes.DelTask: {
      const trainingState: TrainingState = Object.assign({}, state);
      if (trainingState.play && trainingState.play.tasks && trainingState.task_index < trainingState.play.tasks.length) {
        let play = Object.assign({}, trainingState.play)
        let tasks = Object.assign([], play.tasks)
        let task = Object.assign({}, tasks[trainingState.task_index])
        if (task) {
          trainingState.del_movies = {
            movies: task.play_movies,
            patient_id: play._id
          }
        }

        tasks.splice(trainingState.task_index, 1)
        play.tasks = tasks
        trainingState.task_index = -1
        trainingState.scene_index = -1

        trainingState.play = play
        trainingState.save_play = play //DelTask
      }
      return trainingState
    }

    case TrainingActionTypes.SetSegment: {
      const trainingState: TrainingState = Object.assign({}, state);
      trainingState.set_segment = {
        start: action.start,
        end: action.end
      }
      return trainingState
    }


    case TrainingActionTypes.AddScene: {
      // console.log("training reducer SetSceneStart")
      const trainingState: TrainingState = Object.assign({}, state);
      // let new_scene = Object.assign({}, trainingState.scene)
      // if (!new_scene.movie_name && trainingState.task && trainingState.task.play_movies && trainingState.task.play_movies.length > 0) {
      //   let keys = Object.keys(trainingState.task.play_movies)
      //   new_scene.movie_name = keys[0]
      //
      // }
      // if (trainingState.task.scenes) {
      //   new_scene.index = trainingState.task.scenes.length
      // } else {
      //   new_scene.index = 0
      // }
      // if (new_scene.movie_name) {
      //   trainingState.scene = new_scene
      //   setScene(trainingState, action.name, parseFloat(action.start.toFixed(3)), parseFloat(action.end.toFixed(3)))
      // }
      return trainingState;
    }






    default: {
      return state;
    }
  }
}

//******************************************************************************
// Funtions
//******************************************************************************
function setTaskIndex(trainingState: TrainingState, index: number) {
  if (trainingState.play.tasks && trainingState.play.tasks.length > index) {
    trainingState.task_index = index
    let task = trainingState.play.tasks[trainingState.task_index]
    if (task && task.scenes && task.scenes.length > 0) { //We allways start in zero, the user can chenge it
      trainingState.scene_index = 0
    }
  }
}


function delStep(trainingState: TrainingState, scene_index: number) {
  let play = Object.assign({}, trainingState.play)
  let tasks = Object.assign([], play.tasks)
  let index = trainingState.task_index
  let task = Object.assign({}, tasks[index])
  console.log(index + " " + JSON.stringify(tasks) + " " + JSON.stringify(task))
  let scenes = Object.assign([], task.scenes)
  let scene = Object.assign({}, scenes[scene_index])
  if (scene) {
    scenes.splice(scene_index, 1)
    task.scenes = scenes
    tasks[trainingState.task_index] = task
    play.tasks = tasks;
    trainingState.play = play
    trainingState.save_play = play //delStep
  }
}
function delTeacherVideo(trainingState: TrainingState, scene_index: number, act: string) {
  let play = Object.assign({}, trainingState.play)
  let tasks = Object.assign([], play.tasks)
  let index = trainingState.task_index
  let task = Object.assign({}, tasks[index])
  console.log(index + " " + JSON.stringify(tasks) + " " + JSON.stringify(task))
  let scenes = Object.assign([], task.scenes)
  let scene = Object.assign({}, scenes[scene_index])
  if (scene[act]) {
    delete scene[act]
    trainingState.curr_time = scene.start //restart the scene
    trainingState.pause++
    scenes[scene_index] = scene
    task.scenes = scenes
    tasks[trainingState.task_index] = task
    play.tasks = tasks;
    trainingState.play = play
    trainingState.save_play = play//delTeacherVideo
  }
}
function doneRecording(trainingState: TrainingState, duration: number, bIsTask: boolean, data: any) {
  if (trainingState.play && trainingState.play.tasks && trainingState.act && trainingState.task_index >= 0 && trainingState.scene_index >= 0) {
    let movie_name
    trainingState.curr_time = 0
    if (data.fname) {
      movie_name = data.fname
    } else {
      if (bIsTask) {
        movie_name = "task" + data.mime_ext
      } else {
        movie_name = trainingState.act + "_" + trainingState.scene_index + data.mime_ext
      }
    }

    let task = Object.assign({}, trainingState.play.tasks[trainingState.task_index])
    let play_movies = Object.assign({}, task.play_movies)
    let movie: any = {
      name: movie_name,
      duration: duration,
      width: data.width,
      height: data.height
    }
    if (data.url) {
      movie.url = data.url
    }
    play_movies[movie_name] = movie
    task.play_movies = play_movies
    // trainingState.movies = play_movies
    // trainingState.task = task
    let scene: any = Object.assign({}, task.scenes[trainingState.scene_index])
    if (bIsTask) {
      scene = {
        movie_name: movie_name,
      }
      if (!scene.name) {
        scene.name = "Step 1"
      }
      if (!scene.start) {
        scene.start = 0
      }
      if (!scene.end) {
        scene.end = duration
      }
      if (!scene.index) {
        scene.index = 0
      }
      //Task Changed will play the scene  playScene(trainingState, scene) // this will set the movie
    } else {
      scene[trainingState.act] = {
        movie_name: movie_name,
      }
      if (data.url) { //This is the one to play it back, usualy we get it from the server when we load the task
        scene[trainingState.act].url = data.url
      }
    }
    let scenes = Object.assign([], task.scenes)
    scenes[trainingState.scene_index] = scene
    task.scenes = scenes

    let play = Object.assign({}, trainingState.play)
    let tasks = Object.assign([], play.tasks)
    tasks[trainingState.task_index] = task
    play.tasks = tasks;
    trainingState.play = play

    trainingState.save_play = play //doneRecording


  }
}
function delSketchAt(trainingState: TrainingState, index: number) {
  if (trainingState.play && trainingState.play.tasks && trainingState.task_index >= 0 && trainingState.scene_index >= 0) {
    let play = Object.assign({}, trainingState.play)
    let tasks = Object.assign([], play.tasks)
    let task = Object.assign({}, tasks[trainingState.task_index])
    let sketches = Object.assign([], task.sketches)
    sketches.splice(index, 1);
    task.sketches = sketches;
    tasks[trainingState.task_index] = task
    play.tasks = tasks;
    trainingState.play = play
  }
}
function setTaskSketcehs(trainingState: TrainingState, sketches: any[], scene_index: number) {
  if (trainingState.play && trainingState.play.tasks && trainingState.task_index >= 0 && trainingState.scene_index >= 0) {
    let play = Object.assign({}, trainingState.play)
    let tasks = Object.assign([], play.tasks)
    let task = Object.assign({}, tasks[trainingState.task_index])
    task.sketches = sketches;
    tasks[trainingState.task_index] = task
    play.tasks = tasks;
    trainingState.play = play
  }
}
function setScene(trainingState: TrainingState, name: string, start: number, end: number) {
  if (trainingState.play && trainingState.play.tasks && trainingState.task_index >= 0 && trainingState.scene_index >= 0) {
    let play = Object.assign({}, trainingState.play)
    let tasks = Object.assign([], play.tasks)
    let task = Object.assign({}, tasks[trainingState.task_index])
    let scenes = Object.assign([], task.scenes)
    let scene = Object.assign({}, scenes[trainingState.scene_index])

    let bChanged: boolean = false
    if (!scene.name || scene.name != name) {
      scene.name = name;
      bChanged = true
    }
    if (!scene.end || scene.end != end) {
      scene.end = end;
      bChanged = true
    }
    if (!scene.start || scene.start != start) {
      scene.start = start;
      bChanged = true
    }

    if (bChanged && scene.start < scene.end) {

      scenes[trainingState.scene_index] = scene
      task.scenes = scenes

      //It it is the last one
      if (trainingState.scene_index + 1 == task.scenes.length) {
        let movie = task.play_movies[scene.movie_name]
        if (movie && end < movie.duration) {
          let start = scene.end
          let end = movie.duration

          if (start != end) {
            trainingState.scene_index++
            let new_scene = {
              name: "Scene " + (trainingState.scene_index + 1),
              start: start,
              end: end,
              movie_name: scene.movie_name,
            }
            scenes[trainingState.scene_index] = new_scene

          }
        }
      }
    }
    tasks[trainingState.task_index] = task
    play.tasks = tasks;
    trainingState.play = play
    trainingState.save_play = play //setScene
  }
}

function setZoomAndPan(trainingState: TrainingState, msg: any) {
  if (trainingState.play && trainingState.play.tasks && trainingState.task_index >= 0 && trainingState.scene_index >= 0) {
    let play = Object.assign({}, trainingState.play)
    let tasks = Object.assign([], play.tasks)
    let task = Object.assign({}, tasks[trainingState.task_index])
    let task_zoom = Object.assign({}, task.zoom_pan)
    let act = 'intro'//change also in caer.component to support independent zoom and pan
    let task_zoom_act = Object.assign({}, task_zoom[act])

    task_zoom_act[msg.time] = msg
    task_zoom[trainingState.act] = task_zoom_act
    task.zoom_pan = task_zoom
    tasks[trainingState.task_index] = task
    play.tasks = tasks;
    trainingState.play = play

  }
}
